export default __webpack_public_path__ + "static/media/d3.f698b20a.png";